<script lang="ts">
import { defineComponent } from 'vue'
import ProgressIndicator from '@/components/loading/ProgressIndicator.vue'
import { useScreenLockStore } from '@/stores/screenLock'

export default defineComponent({
  name: 'WaitProcess',

  components: {
    ProgressIndicator,
  },

  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
  },

  setup() {
    const screenLockStore = useScreenLockStore()

    return {
      screenLockStore,
    }
  }
})
</script>

<template>
  <transition name="is-fade">
    <section
      v-show="isShow"
      class="f-section__overlay">
      <div class="f-section__overlay--body">
        <ProgressIndicator
          size="large"
          :color="screenLockStore.isBlackOut ? 'white' : 'gray'">
          loading
        </ProgressIndicator>

        <div
          class="o-label__waitProcess"
          :data-color="screenLockStore.isBlackOut ? 'white' : 'gray'">
          <p class="o-label__waitProcess--item">
            しばらくお待ち下さい
          </p>
        <!-- /.o-label__waitProcess --></div>
      <!-- /.f-section__overlay body --></div>
    <!-- /.f-section__overlay --></section>
  </transition>
</template>

<style lang="sass" scoped>
.o-label__waitProcess
  $root: &
  margin-top: 1em

  &:first-child
    margin-top: 0

  & &--item
    color: $font-x-dark-gray
    font:
      size: $font-huge
      weight: bold
    text-align: center

  &[data-color="white"]
    #{$root}--item
      color: $font-white
</style>
